import { DataFormProps } from 'types/InputsStoriesCarouselProps';

export function verifyIfFormCanSave(
	dataForm: DataFormProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.title === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título"');
		return;
	}

	if (dataForm.stories.length === 0) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Cadastre pelo menos 1 storie');
		return;
	}

	if (dataForm.schedule?.start !== '' && dataForm.schedule?.end === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Se preencheu a data incial, preenha a data final.');
		return;
	}

	if (dataForm.schedule?.end !== '' && dataForm.schedule?.start === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Se preencheu a data final, preenha a data inicial.');
		return;
	}

	if (
		dataForm.schedule &&
		new Date(dataForm.schedule?.start) > new Date(dataForm.schedule?.end)
	) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data inicial não pode ser depois da data final');
		return;
	}

	if (
		dataForm.schedule &&
		new Date(dataForm.schedule?.end) < new Date(dataForm.schedule?.start)
	) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data final não pode ser antes da data inicial');
		return;
	}

	setCanSaveModuleOnBack(true);
}
